import React from "react"
import styled from "styled-components"

import { ButtonLink } from "../common"

const StyledTagNav = styled.div`
  display: flex;
  flex-wrap: wrap;
  > ${ButtonLink} {
    font-size: 12px;
    background: #fff;
    color: #005d73;
    border: 2px solid #005d73;
    padding: 0.3rem 1.8rem;
    margin-right: 0.4rem;
  }
`

const convertToKebabCase = (string) => {
  return string?.replace(/\s+/g, "-").toLowerCase()
}

export const TagNav = ({ tags }) => {
  return (
    <StyledTagNav>
      {tags?.map((item, index) => {
        const handle = convertToKebabCase(item)

        return (
          <ButtonLink
            key={`ButtonLink-${index}`}
            to={`/resources/tags/${handle}`}
          >
            {item}
          </ButtonLink>
        )
      })}
    </StyledTagNav>
  )
}
